export default {
  title: 'Inizia',
  description: 'Per caricare la pagina corrente, devi completare la guida introduttiva',
  button: 'Inizia',
};
